<div class="obg-reality-check-content" [ngClass]="{'has-overflow': hasOverflow}">
	<div #content class="obg-reality-check-content-wrapper">
		<h1>{{ "reality-check.title" | translate }}</h1>
		<p test-id="reality-check-header" [innerHtml]="realityCheckLoggedIn"></p>
		<p>{{ "reality-check.header-summary" | translate }}</p>
		<p *ngIf="showTotalBets$ | async">
			{{ "reality-check.total-bets" | translate }}
			<span class="obg-reality-check-value" obgSensitiveData> {{ totalBets }}</span>
		</p>
		<p>
			{{ "reality-check.total-wins" | translate }}
			<span class="obg-reality-check-value" obgSensitiveData> {{ totalWins }}</span>
		</p>
		<p>
			{{ "reality-check.net-winning" | translate }}
			<span class="obg-reality-check-value" obgSensitiveData> {{ netWinning }}</span>
		</p>
		<p>{{ "reality-check.message-caption" | translate }}</p>
	</div>
</div>
